import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Card, CardContent, CardHeader, Chip, Divider, Stack, Typography } from '@mui/material';

const UnpaidInvoicesCard = ({ summary, isLoading, isError }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage || i18n.language || 'ro';
  const unpaid = summary?.unpaid;
  return (
    <Card sx={{ minHeight: 520, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader title={t('dashboard.unpaid_invoices')} subheader={t('dashboard.unpaid_value')}
        sx={{ backgroundColor: '#f1f1f1', minHeight: 85 }} />
      <Divider />
      <CardContent sx={{ flex: 1 }}>
        {!unpaid ? (
          <Typography color="text.secondary">{t(isError && !isLoading ? 'dashboard.load_error' : 'dashboard.loading')}</Typography>
        ) : (
          <Stack spacing={2}>
            <Box>
              <Typography variant="h3" component="p">{unpaid.count.toLocaleString(locale)}</Typography>
              <Typography color="text.secondary">{t('dashboard.awaiting_payment')}</Typography>
            </Box>
            <Chip label={t('dashboard.overdue_count', { count: unpaid.overdue_count })}
              color={unpaid.overdue_count ? 'warning' : 'default'} sx={{ alignSelf: 'flex-start' }} />
            {unpaid.count === 0 ? (
              <Typography>{t('dashboard.no_unpaid_invoices')}</Typography>
            ) : (
              <Stack spacing={1}>
                {Object.entries(unpaid.totals).map(([currency, amount]) => (
                  <Box key={currency} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                    <Typography>{currency === 'UNKNOWN' ? t('dashboard.unknown_currency') : currency}</Typography>
                    <Typography fontWeight={600}>{Number(amount).toLocaleString(locale, {
                      minimumFractionDigits: 2, maximumFractionDigits: 2,
                    })}</Typography>
                  </Box>
                ))}
              </Stack>
            )}
            <Divider />
            <Typography variant="body2" color="text.secondary">
              {t('dashboard.partly_paid_count', { count: unpaid.partly_paid_count })}
            </Typography>
            <Typography variant="caption" color="text.secondary">{t('dashboard.partial_balance_note')}</Typography>
          </Stack>
        )}
      </CardContent>
      <Box sx={{ p: 2, pt: 0 }}>
        <Button component={RouterLink} to="/apps/invoices" variant="outlined" fullWidth>
          {t('dashboard.view_invoices')}
        </Button>
      </Box>
    </Card>
  );
};

export default UnpaidInvoicesCard;
